/** @format */
/**
 * External dependencies
 */
import React from 'react';

const EnabledCurrenciesModalCheckboxList = ( { children } ) => {
	return <ul>{ children }</ul>;
};

export default EnabledCurrenciesModalCheckboxList;
